import { render, staticRenderFns } from "./HeartBox.vue?vue&type=template&id=03178c2b&"
import script from "./HeartBox.vue?vue&type=script&lang=js&"
export * from "./HeartBox.vue?vue&type=script&lang=js&"
import style0 from "./HeartBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports